const fieldNames: Record<string, string> = {
  username: 'Логин',
  email: 'Электронная почта',
  firstName: 'Имя',
  lastName: 'Фамилия',
  middleName: 'Отчество',
  phoneNumber: 'Телефон',
  bskNumber: 'Номер БСК',
  allowedIpNetworks: 'Разрешённые IP-адреса',
};
const fieldHints: Record<string, string> = {
  username: 'допустимы строчные латинские буквы, цифры и разрешённые символы',
  firstName: 'используйте русские буквы, пробел или дефис',
  lastName: 'используйте русские буквы, пробел или дефис',
  middleName: 'используйте русские буквы, пробел или дефис',
  phoneNumber: 'нужны 10 цифр номера без +7 или 8',
  bskNumber: 'от 1 до 16 латинских букв или цифр; номер должен быть уникальным',
  email: 'проверьте формат и уникальность адреса',
  allowedIpNetworks: 'проверьте адреса и маски подсетей',
};
export function userSaveError(error: unknown): string {
  const response = objectValue(error);
  const payload = objectValue(response?.['error']);
  const code = payload?.['error'];
  if (code === 'initial_administrator_protected')
    return 'Первый администратор защищён: нельзя снять его полномочия, заблокировать или удалить учётную запись. Данные не сохранены.';
  if (code === 'full_access_inherited')
    return 'Полный доступ предоставлен ролью или группой. Обновите карточку и измените соответствующее назначение.';
  if (code === 'full_access_not_configured')
    return 'В IAM не настроен полный прикладной доступ. Обратитесь к администратору развёртывания.';
  if (response?.['status'] === 409)
    return 'Логин, email или БСК уже используются. Проверьте данные.';
  const fields = payload?.['fields'];
  if (Array.isArray(fields)) {
    const details = fields
      .map((item) => objectValue(item)?.['field'])
      .filter((field): field is string => typeof field === 'string')
      .map(
        (field) =>
          `${fieldNames[field] ?? field}: ${fieldHints[field] ?? 'проверьте значение'}.`,
      )
      .join(' ');
    if (details) return details;
  }
  return 'Не удалось сохранить пользователя. Проверьте поля и права доступа.';
}

function objectValue(value: unknown): Record<string, unknown> | null {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}
